export default __webpack_public_path__ + "static/media/Newspaper time.2721bb8c.jpg";